// Module
var code = "<p class=\"circle\">3</p> <p>Enter payment information&mdash;you can save your bank account for future use.</p> ";
// Exports
export default code;